var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarPearl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.1738C14.4706 18.1738 18.5 14.1444 18.5 9.17383C18.5 4.20327 14.4706 0.173828 9.5 0.173828C4.52944 0.173828 0.5 4.20327 0.5 9.17383C0.5 14.1444 4.52944 18.1738 9.5 18.1738Z",
    fill: "url(#paint0_linear_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.1738C14.4706 18.1738 18.5 14.1444 18.5 9.17383C18.5 4.20327 14.4706 0.173828 9.5 0.173828C4.52944 0.173828 0.5 4.20327 0.5 9.17383C0.5 14.1444 4.52944 18.1738 9.5 18.1738Z",
    fill: "url(#paint1_radial_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4949 9.17383C15.4837 12.3738 12.7272 15.1255 9.50198 15.1543C6.27636 15.1578 3.54275 12.4062 3.53125 9.17383C3.54275 5.94146 6.27632 3.18985 9.50198 3.19336C12.7273 3.22209 15.4837 5.97384 15.4949 9.17383Z",
    fill: "url(#paint2_linear_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5787 13.5279C7.32141 13.5474 4.60274 10.8223 4.61744 7.56781C4.62292 6.69966 4.82141 5.87318 5.16791 5.12305C4.16311 6.2015 3.53062 7.62181 3.53125 9.17445C3.54275 12.4068 6.27632 15.1585 9.50198 15.1549C11.8803 15.144 13.9792 13.6325 14.9507 11.5856C13.8435 12.7493 12.2879 13.5145 10.5787 13.5279Z",
    fill: "url(#paint3_linear_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70582 4.62437C8.70695 6.11711 7.49779 7.32739 6.00632 7.33464C4.5152 7.339 3.31514 6.16095 3.35241 4.69627C3.39143 3.23215 4.62049 1.98653 6.07118 1.95183C7.52215 1.91885 8.70231 3.13227 8.70582 4.62437Z",
    fill: "url(#paint4_radial_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6659 13.6103C15.6186 15.0606 14.3779 16.3079 12.9273 16.3586C11.4763 16.4075 10.3076 15.2076 10.3125 13.7161C10.3199 12.224 11.5312 11.012 13.0227 11.002C14.5138 10.9949 15.7117 12.1595 15.6659 13.6103Z",
    fill: "url(#paint5_radial_1_77578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07743 6.1993L7.03163 6.2977L6.92348 6.30698L1.41713 6.77952L1.4011 6.59272L1.41712 6.77952C1.2982 6.78972 1.22557 6.85981 1.19909 6.9352C1.17324 7.00882 1.18776 7.09456 1.26886 7.16049L5.42347 10.5375L5.51541 10.6122L5.48737 10.7273L4.27149 15.7189C4.25046 15.8053 4.28631 15.8861 4.36503 15.9391C4.44476 15.9927 4.55489 16.006 4.65479 15.9511L9.40971 13.3387L9.5 13.2891L9.59028 13.3387L14.3452 15.9511C14.4451 16.006 14.5552 15.9927 14.635 15.939C14.7137 15.8861 14.7495 15.8053 14.7285 15.7189L14.9107 15.6746L14.7285 15.7189L13.5127 10.7273L13.4846 10.6122L13.5766 10.5375L17.7311 7.16049C17.7311 7.16049 17.7311 7.16049 17.7311 7.16049C17.8122 7.09455 17.8268 7.00881 17.8009 6.93519C17.7744 6.85981 17.7018 6.78972 17.5829 6.77952L17.5829 6.77952L12.0765 6.30695L11.9684 6.29766L11.9226 6.19926L9.73527 1.49974L9.73526 1.49972C9.69475 1.41266 9.60485 1.36132 9.50001 1.36132C9.39518 1.36132 9.30525 1.41266 9.26472 1.49974L7.07743 6.1993Z",
    fill: "white",
    stroke: "#FF81BE",
    strokeWidth: 0.374976
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29012 7.96966C6.28653 9.16093 5.32149 10.124 4.12826 10.1167C2.93544 10.1082 1.95936 9.1565 1.96882 7.99504C1.97891 6.83376 2.96522 5.86458 4.15118 5.84215C5.33749 5.82084 6.29233 6.77857 6.29012 7.96966Z",
    fill: "url(#paint6_radial_1_77578)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_77578",
    x1: 3.13602,
    y1: 15.5377,
    x2: 15.8639,
    y2: 2.80981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_77578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.5 9.17383) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#FF353A",
    stopOpacity: 0.931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#FF527D",
    stopOpacity: 0.603
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#FF66AD",
    stopOpacity: 0.327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FF73CB",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF78D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_77578",
    x1: 3.61995,
    y1: 15.0492,
    x2: 16.4946,
    y2: 2.17464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFC6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FFEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_77578",
    x1: 5.17379,
    y1: 13.4987,
    x2: 16.0498,
    y2: 2.62266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_77578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.03145 4.64515) scale(2.6858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_77578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9961 13.6877) scale(2.67954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_77578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.13124 7.9832) scale(2.15019)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPearl);
export default __webpack_public_path__ + "static/media/star_pearl.fe868f7a360d219017b26652f51902c8.svg";
export { ForwardRef as ReactComponent };